export default __webpack_public_path__ + "static/media/error-page-403.46a801ac.png";